import React from 'react'
import { Layout} from 'antd'
import Media from 'react-media'
import Images from 'Assets/Images'
import './styles.css'

const Header = () => {
  return (
    <Layout.Header className='header-container'>
      <Media queries={{
          small: '(max-width: 567px)',
          large: '(min-width: 568px)'
        }}>
          {matches => (
            <>
              {matches.small && <img className='img' src={Images.introMobile} alt='' />}
              {matches.large && <img className='img' src={Images.intro} alt='' />}
            </>
          )}
        </Media>
    </Layout.Header>
  )
}

export default Header